/****************************************************************/
/*                                                              */
/*                This is an Auto-Generated File                */
/*                           Made By                            */
/*             Namirasoft SDK Generator NPM Package             */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*          Please do not make any change to this file          */
/*    If any change is required, ns-sdkg command must be used   */
/*                                                              */
/****************************************************************/
/****************************************************************/
/*                                                              */
/*                 Namira Software Corporation                  */
/*                    https://namirasoft.com                    */
/*                                                              */
/****************************************************************/

import { FilterItem } from "namirasoft-core";
import { NamirasoftJobArrangerServer } from "./NamirasoftJobArrangerServer";
import { NamirasoftJobArrangerServerBase } from "./NamirasoftJobArrangerServerBase";
import { ReasonFullRow } from "./row/ReasonFullRow";
import { ReasonInputRow } from "./row/ReasonInputRow";
import { ReasonRow } from "./row/ReasonRow";
import { SortItem } from "namirasoft-core";

export class NamirasoftJobArrangerServerReason extends NamirasoftJobArrangerServerBase
{
    constructor(server: NamirasoftJobArrangerServer)
    {
        super(server);
        this.List = this.List.bind(this);
        this.Get = this.Get.bind(this);
        this.Create = this.Create.bind(this);
        this.Update = this.Update.bind(this);
        this.Delete = this.Delete.bind(this);
    }
    async List(filters: FilterItem[] | null, page: (number | null), size: (number | null), sorts: SortItem[]): Promise<{ rows: ReasonRow[], count: number }>
    {
        let filters_string_value: string = FilterItem.stringify(filters);
        let sorts_string_value: string = SortItem.stringify(sorts);
        let path = `/reason/list`;
        let { data } = await this.server._get<{ rows: ReasonRow[], count: number }>(path, { filters: filters_string_value, page, size, sorts: sorts_string_value });
        return data;
    }
    async Get(id: string): Promise<ReasonFullRow>
    {
        let path = `/reason/${id}`;
        let { data } = await this.server._get<ReasonFullRow>(path, {});
        return data;
    }
    async Create(body: ReasonInputRow): Promise<ReasonRow>
    {
        let path = `/reason`;
        let { data } = await this.server._post<ReasonRow>(path, {}, body);
        return data;
    }
    async Update(id: string, body: ReasonInputRow): Promise<ReasonRow>
    {
        let path = `/reason/${id}`;
        let { data } = await this.server._put<ReasonRow>(path, {}, body);
        return data;
    }
    async Delete(id: string): Promise<void>
    {
        let path = `/reason/${id}`;
        await this.server._delete<void>(path, {});
    }
};